import React from "react";

/* Payment Icons Component */
export default function PaymentIcons({}) {
  return (
    <div className="payment-ico">
      <ul className="inline-list payment-icons">
        <li className="amex">
          <img src="https://cdn3.iconfinder.com/data/icons/flat-icons-web/40/Amex-512.png" />
        </li>

        <li className="apple">
          <img src="https://cdn1.iconfinder.com/data/icons/logos-and-brands-3/512/23_Apple_Pay_Credit_Card_logo_logos-256.png" />
        </li>

        <li className="diners">
          <img src="https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/90_Diners_Club_Credit_Card_logo_logos-512.png" />
        </li>

        <li className="discover">
          <img src="https://cdn0.iconfinder.com/data/icons/credit-card-debit-card-payment-PNG/128/Discover-Curved.png" />
        </li>

        <li className="google">
          <img src="https://cdn1.iconfinder.com/data/icons/logos-brands-in-colors/436/Google_Pay_GPay_Logo-512.png" />
        </li>

        <li className="jcb">
          <img src="https://cdn3.iconfinder.com/data/icons/payment-method/480/jcb_card_payment-512.png" />
        </li>

        <li className="mastercard">
          <img src="https://cdn4.iconfinder.com/data/icons/logos-3/565/Mastercard-icon-512.png" />
        </li>

        <li className="shopify">
          <img src="https://d9c1pg7kld2pm.cloudfront.net/shoppay.svg" />
        </li>

        <li className="visa">
          <img src="https://cdn0.iconfinder.com/data/icons/credit-card-debit-card-payment-PNG/128/Visa-Curved.png" />
        </li>
      </ul>
    </div>
  );
}
